// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Fm-z","tupacHeader":"Gm-z","tupacHeader2":"Hm-z","tupacMenu":"Im-z","tupacMenu2":"Jm-z","tupacMain":"Km-z","tupacMain2":"Lm-z"};